import type { Language } from '../content';
import { Link } from 'react-router-dom';

type BrandProps = {
  language: Language;
  tagline: string;
  compact?: boolean;
};

export function Brand({ language, tagline, compact = false }: BrandProps) {
  return (
    <Link className={`brand ${compact ? 'brand--compact' : ''}`} to="/" aria-label="Dental Lab System">
      <span className="brand__mark">
        <img src="/dental-lab-system-logo.png" alt="" width="52" height="52" />
      </span>
      <span className="brand__copy">
        <strong>DENTAL</strong>
        <span>LAB SYSTEM</span>
        {!compact && <small lang={language}>{tagline}</small>}
      </span>
    </Link>
  );
}
